import React from 'react';
import FloatingShapes from "../common/FloatingShapes";

const timeAllocationData = [
  {
    label: "Өглөөний хөтөлбөр",
    perDay: "3 цаг/өдөр",
    total: "36-40 цаг",
    description:
      "Нийт амрагчдыг хамарсан бүлгэмийн хэмжээнд, мэргэжлийн хөтөлбөр удирдагчид, багш нарын хамтарсан багийн удирдлагаар зохион байгуулагдана",
    icon: "☀️",
  },
  {
    label: "Үдээс хойшхи хөтөлбөр",
    perDay: "1.5 цаг/өдөр",
    total: "",
    description:
      "Бүлгийн болон 2-3 бүлэг дундын хүрээнд бүлгийн удирдсан багшийн удирдлагаар",
    icon: "🌤",
  },
  {
    label: "Оройн хөтөлбөр",
    perDay: "1.5 цаг/өдөр",
    total: "",
    description:
      "Хөгжөөнт, цэнгээнт, энтертаймент шоу хэлбэрийн хөтөлбөрүүд",
    icon: "🌙",
  },
  {
    label: "Хооллох",
    perDay: "5 удаа, 5 цаг/өдөр",
    total: "35 цаг",
    description: "",
    icon: "🍽",
  },
  {
    label: "Чөлөөт цаг",
    perDay: "5 цаг/өдөр",
    total: "35 цаг",
    description: "",
    icon: "⏳",
  },
];

const day1Programs = {
  ihUdiin: {
    time: "10:00-12:30",
    label: "ИХ ҮДИЙН",
    rows: [
      {
        ageGroup: "Бүх нас",
        winter:
          "Хүлээн авах, бүлэг өрөө зохион байгуулалт, Өргөө гэр Найрамдал хөтөлбөр (дүрэм, аюулгүй байдлын зааварчилгаа)",
        springSummer:
          "Хүлээн авах, бүлэг өрөө зохион байгуулалт, Өргөө гэр Найрамдал хөтөлбөр (дүрэм, аюулгүй байдлын зааварчилгаа)",
      },
    ],
  },
  bagaUdiin: {
    time: "17:00-18:30",
    label: "БАГА ҮДИЙН",
    rows: [
      {
        ageGroup: "6-10 нас",
        winter: "Нэг бүлэг - Нэг баг бүлгийн ажил",
        springSummer: "Нэг бүлэг - Нэг баг бүлгийн ажил",
      },
      {
        ageGroup: "11-14 нас",
        winter: "Icebreaker + баг бүрдүүлэх",
        springSummer: "Outdoor team game",
      },
      {
        ageGroup: "15-18 нас",
        winter: "Fitness challenge",
        springSummer: "Манлайллын дасгал",
      },
    ],
  },
};

const projectPrograms = [
  {
    ageGroup: "6-10 нас",
    color: "from-green-400 to-emerald-500",
    bgColor: "bg-green-50",
    borderColor: "border-green-200",
    items: [
      "Шүрэн урлал",
      "Уран зураг",
      "Уяа зангилаа",
      "Дуу/бүжиг",
      "Үкүлэлэ/калимба",
      "Лего робот",
    ],
  },
  {
    ageGroup: "11-14 нас",
    color: "from-blue-400 to-indigo-500",
    bgColor: "bg-blue-50",
    borderColor: "border-blue-200",
    items: [
      "Шүрэн урлал",
      "Уран зураг",
      "Уяа зангилаа",
      "Дуу/бүжиг",
      "Үкүлэлэ/калимба",
      "Лего робот",
      "Спорт өрөлт",
      "Ширээний теннис/бөмбөг",
      "Анхны тусламж",
      "Үндэсний өв уламжлал",
      "Лего робот програмчлал",
    ],
  },
  {
    ageGroup: "15-18 нас",
    color: "from-purple-400 to-violet-500",
    bgColor: "bg-purple-50",
    borderColor: "border-purple-200",
    items: [
      "Шүрэн урлал",
      "Уран зураг",
      "Уяа зангилаа",
      "Дуу/бүжиг",
      "Үкүлэлэ/калимба",
      "Лего робот",
      "Спорт өрөлт",
      "Ширээний теннис/бөмбөг",
      "Анхны тусламж",
      "Үндэсний өв уламжлал",
      "Лего робот програмчлал",
      "Уулын дугуй",
      "Ханан хадны хөтөлбөр",
      "VR контент",
      "Монгол гэр барих",
    ],
  },
];

const entertainmentPrograms = [
  {
    title: "Тоглоомын тойрог",
    description:
      "140 орчим тоглоомуудаас бүлгийн онцлогт тохируулан 8-10 тоглоом",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48.39 48.39 0 0 1-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 0 0-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 0 1-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 0 0 5.427-.63 48.05 48.05 0 0 0 .582-4.717.532.532 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.959.401v0a.656.656 0 0 0 .658-.663 48.422 48.422 0 0 0-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 0 1-.61-.58v0Z" />
      </svg>
    ),
  },
  {
    title: "Байгалийн аялал",
    description:
      "Ойн аялал, амьтдын тухай, харанхуй өртөө, дүүжин гүүр",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="m20.893 13.393-1.135-1.135a2.252 2.252 0 0 1-.421-.585l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 0 1-1.383-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18a.94.94 0 0 0-.662.274.931.931 0 0 1-1.458-1.137l1.411-2.353a2.25 2.25 0 0 0 .286-.76m11.928 9.869A9 9 0 0 0 8.965 3.525m11.928 9.868A9 9 0 1 1 8.965 3.525" />
      </svg>
    ),
  },
  {
    title: "Хээрийн аялал",
    description:
      "Байр оромж бэлтгэх, хоол бэлтгэх, зүг чиг олох, анхны тусламж",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.362 5.214A8.252 8.252 0 0 1 12 21 8.25 8.25 0 0 1 6.038 7.047 8.287 8.287 0 0 0 9 9.601a8.983 8.983 0 0 1 3.361-6.867 8.21 8.21 0 0 0 3 2.48Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 18a3.75 3.75 0 0 0 .495-7.468 5.99 5.99 0 0 0-1.925 3.547 5.975 5.975 0 0 1-2.133-1.001A3.75 3.75 0 0 0 12 18Z" />
      </svg>
    ),
  },
  {
    title: "Бүлгийн ажлууд",
    description:
      "Хандлагаа өөрчилье, Найзаа хайрлая, 50 гаруй төрлийн бүлгийн ажил",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
      </svg>
    ),
  },
];

const eveningPrograms = [
  {
    ageGroup: "6-10 нас",
    color: "from-green-400 to-emerald-500",
    bgColor: "bg-green-50",
    borderColor: "border-green-200",
    items: [
      "Тоглоомт дасгал",
      "Шинэ дуу бүжиг сурах",
      "Тойрон бүжгийн баяр",
    ],
  },
  {
    ageGroup: "11-14 нас",
    color: "from-blue-400 to-indigo-500",
    bgColor: "bg-blue-50",
    borderColor: "border-blue-200",
    items: [
      "STEAM тоглоомууд",
      "Галын наадам",
      "Түүдгийн дэргэд",
      "Хаппи тайм",
    ],
  },
  {
    ageGroup: "15-18 нас",
    color: "from-purple-400 to-violet-500",
    bgColor: "bg-purple-50",
    borderColor: "border-purple-200",
    items: [
      "Хөтөлбөрт диско",
      "Дэвжээ",
      "АХА тэмцээн",
      "Кино үдэш",
      "Маскарад шоу",
      "Найрамдлын одод шоу",
      "Галын наадам",
      "Түүдгийн дэргэд",
    ],
  },
];

const SevenDayProgram = () => {
  return (
    <>
      {/* Hero Section - Dark */}
      <div className="relative overflow-hidden bg-primary-800 -mt-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-secondary-500/15 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-secondary-400/10 blur-[100px]" />
          <div className="absolute bottom-20 right-1/4 w-[250px] h-[250px] rounded-full bg-accent-500/10 blur-[80px]" />
        </div>
        <FloatingShapes variant="default" />
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative pt-40 pb-16 sm:pt-48 sm:pb-20">
          <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-secondary-300 backdrop-blur-sm">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-secondary-400 animate-pulse" />
              Бүтээгдэхүүн, үйлчилгээ
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight">
              <span className="bg-gradient-to-r from-secondary-400 to-accent-400 bg-clip-text text-transparent">
                7 хоногийн хөтөлбөр
              </span>
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-slate-400 max-w-4xl mx-auto leading-relaxed">
              ОЛОН УЛСЫН ХҮҮХДИЙН НАЙРАМДАЛ ЦОГЦОЛБОРЫН 7 ӨДРИЙН ҮЛГЭРЧИЛСЭН ХӨТӨЛБӨР
            </p>
          </div>
        </div>
      </div>

      {/* Time Allocation Table - White */}
      <div className="bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900">
              Цаг хуваарилалт
            </h2>
            <p className="mt-4 text-lg text-neutral-600">
              7 хоногийн хөтөлбөрийн цагийн хуваарилалт
            </p>
          </div>

          <div className="space-y-4">
            {timeAllocationData.map((item, index) => (
              <div
                key={index}
                className="bg-neutral-50 rounded-2xl p-6 border border-neutral-100 hover:shadow-lg transition-all duration-300 animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                  <div className="flex items-center gap-4 sm:w-1/3">
                    <span className="text-2xl">{item.icon}</span>
                    <h3 className="text-lg font-bold text-neutral-900">
                      {item.label}
                    </h3>
                  </div>
                  <div className="flex items-center gap-4 sm:w-1/3">
                    <span className="inline-flex items-center rounded-full bg-secondary-100 px-3 py-1 text-sm font-semibold text-secondary-700">
                      {item.perDay}
                    </span>
                    {item.total && (
                      <span className="inline-flex items-center rounded-full bg-accent-100 px-3 py-1 text-sm font-semibold text-accent-700">
                        Нийт: {item.total}
                      </span>
                    )}
                  </div>
                  {item.description && (
                    <p className="text-sm text-neutral-600 sm:w-1/3">
                      {item.description}
                    </p>
                  )}
                </div>
              </div>
            ))}

            {/* Total row */}
            <div className="bg-primary-800 rounded-2xl p-6 text-white">
              <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                <div className="flex items-center gap-4 sm:w-1/3">
                  <span className="text-2xl">📊</span>
                  <h3 className="text-lg font-bold">Нийт</h3>
                </div>
                <div className="flex items-center gap-4">
                  <span className="inline-flex items-center rounded-full bg-white/20 px-3 py-1 text-sm font-semibold">
                    16 цаг/өдөр
                  </span>
                  <span className="inline-flex items-center rounded-full bg-secondary-400/30 px-3 py-1 text-sm font-semibold">
                    Нийт: 112 цаг
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Day 1 - Dark */}
      <div className="relative overflow-hidden bg-primary-800 py-16 sm:py-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -left-40 w-[400px] h-[400px] rounded-full bg-secondary-500/10 blur-[120px]" />
          <div className="absolute bottom-20 right-1/4 w-[300px] h-[300px] rounded-full bg-accent-500/8 blur-[100px]" />
        </div>
        <FloatingShapes variant="alt" />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-secondary-300 backdrop-blur-sm">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-secondary-400 animate-pulse" />
              1-р өдөр
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold">
              <span className="bg-gradient-to-r from-secondary-400 to-accent-400 bg-clip-text text-transparent">
                САЙН БАЙНА УУ НАЙРАМДАЛ
              </span>
            </h2>
          </div>

          {/* ИХ ҮДИЙН */}
          <div className="mb-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-secondary-500 to-secondary-600 flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">
                  {day1Programs.ihUdiin.label}
                </h3>
                <p className="text-sm text-slate-400">
                  {day1Programs.ihUdiin.time}
                </p>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead>
                  <tr>
                    <th className="px-4 py-3 text-sm font-semibold text-secondary-300 bg-white/5 rounded-tl-xl">
                      Насны бүлэг
                    </th>
                    <th className="px-4 py-3 text-sm font-semibold text-secondary-300 bg-white/5">
                      Өвөл
                    </th>
                    <th className="px-4 py-3 text-sm font-semibold text-secondary-300 bg-white/5 rounded-tr-xl">
                      Хавар / Намар
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {day1Programs.ihUdiin.rows.map((row, idx) => (
                    <tr key={idx}>
                      <td className="px-4 py-4 text-sm font-semibold text-white bg-white/[0.03] border-t border-white/5">
                        <span className="inline-flex items-center rounded-full bg-secondary-500/20 px-3 py-1 text-xs font-semibold text-secondary-300">
                          {row.ageGroup}
                        </span>
                      </td>
                      <td className="px-4 py-4 text-sm text-slate-300 bg-white/[0.03] border-t border-white/5">
                        {row.winter}
                      </td>
                      <td className="px-4 py-4 text-sm text-slate-300 bg-white/[0.03] border-t border-white/5">
                        {row.springSummer}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* БАГА ҮДИЙН */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-accent-500 to-accent-600 flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">
                  {day1Programs.bagaUdiin.label}
                </h3>
                <p className="text-sm text-slate-400">
                  {day1Programs.bagaUdiin.time}
                </p>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead>
                  <tr>
                    <th className="px-4 py-3 text-sm font-semibold text-secondary-300 bg-white/5 rounded-tl-xl">
                      Насны бүлэг
                    </th>
                    <th className="px-4 py-3 text-sm font-semibold text-secondary-300 bg-white/5">
                      Өвөл
                    </th>
                    <th className="px-4 py-3 text-sm font-semibold text-secondary-300 bg-white/5 rounded-tr-xl">
                      Хавар / Намар
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {day1Programs.bagaUdiin.rows.map((row, idx) => (
                    <tr key={idx}>
                      <td className="px-4 py-4 text-sm font-semibold text-white bg-white/[0.03] border-t border-white/5">
                        <span className="inline-flex items-center rounded-full bg-accent-500/20 px-3 py-1 text-xs font-semibold text-accent-300">
                          {row.ageGroup}
                        </span>
                      </td>
                      <td className="px-4 py-4 text-sm text-slate-300 bg-white/[0.03] border-t border-white/5">
                        {row.winter}
                      </td>
                      <td className="px-4 py-4 text-sm text-slate-300 bg-white/[0.03] border-t border-white/5">
                        {row.springSummer}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Төсөлт хөтөлбөрүүд - White */}
      <div className="bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900">
              Төсөлт хөтөлбөрүүд
            </h2>
            <p className="mt-4 text-lg text-neutral-600 max-w-3xl mx-auto">
              Амралтын хугацаанд 3 өдөр, нийт 9 цагийн хугацаанд хамрагдах
              төсөлт хөтөлбөрүүд
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {projectPrograms.map((group, index) => (
              <div
                key={index}
                className={`rounded-2xl border ${group.borderColor} ${group.bgColor} p-6 hover:shadow-lg transition-all duration-300 animate-slide-up`}
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className={`inline-flex items-center rounded-full bg-gradient-to-r ${group.color} px-4 py-1.5 text-sm font-bold text-white mb-6`}>
                  {group.ageGroup}
                </div>
                <div className="space-y-2">
                  {group.items.map((item, idx) => (
                    <div
                      key={idx}
                      className="flex items-center gap-2 bg-white rounded-lg px-4 py-2.5 shadow-sm"
                    >
                      <svg className="w-4 h-4 text-secondary-500 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clipRule="evenodd" />
                      </svg>
                      <span className="text-neutral-700 font-medium text-sm">
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Хөгжөөнт хөтөлбөрүүд - Dark */}
      <div className="relative overflow-hidden bg-primary-800 py-16 sm:py-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-1/3 -right-40 w-[400px] h-[400px] rounded-full bg-secondary-500/10 blur-[120px]" />
          <div className="absolute -bottom-20 left-1/4 w-[300px] h-[300px] rounded-full bg-accent-500/8 blur-[100px]" />
        </div>
        <FloatingShapes variant="sparse" />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold">
              <span className="bg-gradient-to-r from-secondary-400 to-accent-400 bg-clip-text text-transparent">
                Хөгжөөнт хөтөлбөрүүд
              </span>
            </h2>
            <p className="mt-4 text-lg text-slate-400 max-w-3xl mx-auto">
              Амралтын хугацаанд явагдах хөгжөөнт хөтөлбөрүүд
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {entertainmentPrograms.map((program, index) => (
              <div
                key={index}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-secondary-500 to-accent-500 flex items-center justify-center text-white shrink-0">
                    {program.icon}
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-white mb-2">
                      {program.title}
                    </h3>
                    <p className="text-sm text-slate-400 leading-relaxed">
                      {program.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Оройн хөтөлбөрүүд - White */}
      <div className="bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900">
              Оройн хөтөлбөрүүд
            </h2>
            <p className="mt-4 text-lg text-neutral-600">(20:00-21:30)</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {eveningPrograms.map((group, index) => (
              <div
                key={index}
                className={`rounded-2xl border ${group.borderColor} ${group.bgColor} p-6 hover:shadow-lg transition-all duration-300 animate-slide-up`}
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className={`inline-flex items-center rounded-full bg-gradient-to-r ${group.color} px-4 py-1.5 text-sm font-bold text-white mb-6`}>
                  {group.ageGroup}
                </div>
                <div className="space-y-2">
                  {group.items.map((item, idx) => (
                    <div
                      key={idx}
                      className="flex items-center gap-2 bg-white rounded-lg px-4 py-2.5 shadow-sm"
                    >
                      <svg className="w-4 h-4 text-accent-500 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z" clipRule="evenodd" />
                      </svg>
                      <span className="text-neutral-700 font-medium text-sm">
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SevenDayProgram;
